export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full max-w-md">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20sleek%20streaming%20video%20app%20interface%20with%20movie%20thumbnails%2C%20dark%20theme%20with%20warm%20accent%20colors%2C%20floating%20on%20a%20clean%20gradient%20background%2C%20minimalist%20product%20photography%2C%20premium%20app%20aesthetic&width=600&height=800&seq=app-mockup&orientation=portrait"
                alt="玫瑰视频移动端体验"
                className="w-full h-auto rounded-xl"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              移动客户端
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              玫瑰视频完美适配手机浏览器访问，随时随地追剧不设限。
              无需下载安装任何APP，打开浏览器输入网址即可畅享高清观影体验。
              支持iOS Safari、Android Chrome等主流移动浏览器，自动适配屏幕尺寸，
              横屏竖屏随心切换，给你掌上影院的沉浸感受。
            </p>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap">
                <i className="ri-smartphone-line"></i>
                手机端立即体验
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                <i className="ri-qr-code-line"></i>
                扫码快速访问
              </span>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                无需下载安装
              </span>
              <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                iOS/Android通用
              </span>
              <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                流量消耗极低
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}